import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import {
  ValidationProvider,
  ValidationObserver,
  extend,
} from "vee-validate/dist/vee-validate.full";
import { required, email } from "vee-validate/dist/rules";
import VueTelInput from "vue-tel-input";
import "./firebase";
import "./assets/css/bootstrap.min.css";
import "./assets/css/styles.scss";

extend("required", {
  ...required,
  message: "El campo es requerido",
});
extend("email", {
  ...email,
  message: "El campo debe ser un email",
});

const number_phone = {
  validate: (value) => {
    const MOBILEREG = /\+?\d[\d\s]{8,15}\d/;
    return MOBILEREG.test(value);
  },
  message(field) {
    return `El ${field} tiene que ser en un formato válido.`;
  },
};

const only_text = {
  validate: (value) => {
    const nameRegex = /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z])$/;
    return nameRegex.test(value);
  },
  message(field) {
    return `En el campo ${field} solo puedes ingresar texto sin espacios`;
  },
};

extend("number_phone", number_phone);
extend("only_text", only_text);

Vue.use(VueTelInput);
Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
